
<div class="row">
    <div class="col-12">
    
        <div class="card">

            <div class="card-header">
                <div class="title">{{ 'PRODUCT.PRODUCT_INFO' | translate }}</div>
                <div class="tools">
                    <button type="button" class="btn btn-light mr-2 btn-sm btn-back"  routerLink="/products">
                        <!-- <i class="bi bi-arrow-left-square"></i> -->
                        {{ 'BACK' | translate }}
                      </button>

                    <button type="button" class="btn btn-primary btn-sm btn-create" (click)="onCreate()">
                        <!-- <i class="bi bi-save"></i> -->
                        {{ 'SAVE' | translate }}
                    </button>
                </div>
            </div>

            <div class="card-body">

                <app-addinfo></app-addinfo>

            </div>

        </div>

    </div>
</div>